export type ShopNavMatch = {
  to: string;
  end?: boolean;
  match?: string[];
};

export function isShopNavPathActive(pathname: string, item: ShopNavMatch): boolean {
  if (item.end) return pathname === item.to;
  const prefixes = [item.to, ...(item.match ?? [])];
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
